import axios from 'axios';

const getEnv = (key) => {
  if (typeof process !== 'undefined' && process.env && process.env[key]) {
    return process.env[key];
  }
  return undefined;
};

const GRAPHQL_URL = getEnv('REACT_APP_GRAPHQL_URL') || '/graphql';
const GRAPHQL_TIMEOUT_MS = Number(getEnv('REACT_APP_GRAPHQL_TIMEOUT_MS') || 10000);

export const graphqlRequest = (query, variables = {}, token) =>
  axios({
    method: 'post',
    url: GRAPHQL_URL,
    timeout: GRAPHQL_TIMEOUT_MS,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { 'x-token': token } : {}),
    },
    data: {
      query,
      variables,
    },
  });

export const graphqlUploadRequest = (query, variables = {}, file, token) => {
  const formData = new FormData();
  formData.append(
    'operations',
    JSON.stringify({
      query,
      variables,
    })
  );
  formData.append('map', JSON.stringify({ '0': ['variables.file'] }));
  formData.append('0', file);

  return axios({
    method: 'post',
    url: GRAPHQL_URL,
    timeout: GRAPHQL_TIMEOUT_MS,
    headers: {
      ...(token ? { 'x-token': token } : {}),
    },
    data: formData,
  });
};

export const assetUrl = (path) => {
  const baseUrl = getEnv('REACT_APP_ASSETS_URL')
    || getEnv('REACT_APP_API_URL')
    || '';
  const normalizedBase = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
  const normalizedPath = path.startsWith('/') ? path.slice(1) : path;
  return normalizedBase ? `${normalizedBase}/${normalizedPath}` : `/${normalizedPath}`;
};
